module.exports = __webpack_public_path__ + "static/media/ico-search-hover.ce1eb180.svg";